import React from "react"
import { Card, CardBody, Badge, Button } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"

const RoleListComponent = ({ data, error, loading, onDeleteRole }) => {
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"Roles"}
            rowCount={false}
            orderingList={false}
            searchBox={false}
            rightBtn={true}
            rightBtnTitle={"Add Role"}
            rightBtnRoute={"/add-role"}
            orderingOptions={[{ value: "id", name: "ID" }]}
          />

          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data}
            loading={loading}
            headers={["#", "Role Name", "Type", "Permissions", "Users", "Actions"]}
            renderItem={(role, index) => {
              const isSystemRole = ["Admin", "Provider", "Province", "Monitor"].includes(
                role.name
              )
              const permissionsCount = role.permissions_count || (role.permissions && role.permissions.length) || 0
              const usersCount = role.users_count || 0

              return (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-16">
                          <i className="bx bx-user-circle"></i>
                        </span>
                      </div>
                      <div>
                        <h5 className="font-size-14 mb-0">{role.name}</h5>
                      </div>
                    </div>
                  </td>
                  <td>
                    {isSystemRole ? (
                      <Badge color="primary" className="font-size-12" pill>
                        <i className="bx bx-shield me-1"></i>
                        System Role
                      </Badge>
                    ) : (
                      <Badge color="info" className="font-size-12" pill>
                        <i className="bx bx-user me-1"></i>
                        Custom Role
                      </Badge>
                    )}
                  </td>
                  <td>
                    <Badge color="success" className="font-size-12" pill>
                      <i className="bx bx-lock-alt me-1"></i>
                      {permissionsCount} {permissionsCount === 1 ? "Permission" : "Permissions"}
                    </Badge>
                  </td>
                  <td>
                    <Badge color="secondary" className="font-size-12" pill>
                      <i className="bx bx-user me-1"></i>
                      {usersCount} {usersCount === 1 ? "User" : "Users"}
                    </Badge>
                  </td>
                  <td>
                    {/* Render action columns with Edit and conditional Delete  */}
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="primary"
                        outline
                        onClick={() => navigate(`/edit-role/${role.id}`)}
                      >
                        <i className="bx bx-edit-alt me-1"></i>
                        Edit Permissions
                      </Button>
                      {!isSystemRole && (
                        <Button
                          size="sm"
                          color="danger"
                          outline
                          onClick={() => {
                            if (
                              window.confirm(
                                `Are you sure you want to delete the role "${role.name}"?${usersCount > 0 ? ` This role is assigned to ${usersCount} user(s).` : ''}`
                              )
                            ) {
                              onDeleteRole(role.id)
                            }
                          }}
                        >
                          <i className="bx bx-trash me-1"></i>
                          Delete
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              )
            }}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default RoleListComponent
